<table mat-table [dataSource]="datasource" class="paginatedTable bordered-table">
  <ng-container matColumnDef="select">
    <th class="centered-cell" mat-header-cell *matHeaderCellDef>
      <mat-checkbox class="cellCheckbox" (change)="$event ? masterToggle() : null"
                    [checked]="isAllSelected()"
                    [indeterminate]="(selectedUnitIds()?.length || 0) > 0 && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row" class="col-xs centered-cell">
      <mat-checkbox class="cellCheckbox" (click)="$event.stopPropagation()"
                    (change)="$event ? unitSelected(row) : null" [checked]="isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="userTag">
    <th mat-header-cell *matHeaderCellDef>Tag</th>
    <td mat-cell *matCellDef="let record">{{ record.unitData.userTag }}</td>
  </ng-container>
  <ng-container matColumnDef="coolingTargetTotalLoad">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getCapacityUnits()">Target Total</th>
    <td mat-cell *matCellDef="let record">{{ record.unitData.coolingTargetTotalLoad | number: '1.0-0' }}</td>
  </ng-container>
  <ng-container matColumnDef="heatingTargetTotalLoad">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getCapacityUnits()">Target Total</th>
    <td mat-cell *matCellDef="let record">{{ record.unitData.heatingTargetTotalLoad | number: '1.0-0' }}</td>
  </ng-container>
  <ng-container matColumnDef="flowRate">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getFlowRateUnits()">Flow Rate</th>
    <td mat-cell *matCellDef="let record">{{ getFluidFlowRate(record) | number: '1.0-1' }}</td>
  </ng-container>
  <ng-container matColumnDef="modelSize">
    <th mat-header-cell *matHeaderCellDef>Model/Size</th>
    <td mat-cell *matCellDef="let record">{{ (record.unitData?.sureFlowRatingUnit?.modelCode || '') + (record.unitData?.sureFlowRatingUnit?.sizeCode || '') }}</td>
  </ng-container>
  <ng-container matColumnDef="coilRows">
    <th mat-header-cell *matHeaderCellDef>Coil Rows</th>
    <td mat-cell *matCellDef="let record">{{ record.unitData?.sureFlowRatingUnit?.coilRowCode }}</td>
  </ng-container>
  <ng-container matColumnDef="fanSpeed">
    <th mat-header-cell *matHeaderCellDef>Fan Speed</th>
    <td mat-cell *matCellDef="let record">{{ record.unitData?.sureFlowRatingUnit?.request?.fanSpeed }}</td>
  </ng-container>
  <ng-container matColumnDef="esp">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getStaticPressureUnits()">ESP</th>
    <td mat-cell *matCellDef="let record">{{ record.unitData?.sureFlowRatingUnit?.request?.externalStaticPressure | number: '1.0-2' }}</td>
  </ng-container>
  <ng-container matColumnDef="airflow">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getAirflowUnits()">Airflow</th>
    <td mat-cell *matCellDef="let record">{{ record.unitData?.sureFlowRatingUnit?.response?.airflow | number: '1.0-0' }}</td>
  </ng-container>
  <ng-container matColumnDef="edb">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getTemperatureUnits()">EDB</th>
    <td mat-cell *matCellDef="let record">{{ getEnteringDryBulb(record) | number: '1.0-1' }}</td>
  </ng-container>
  <ng-container matColumnDef="ewb">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getTemperatureUnits()">EWB</th>
    <td mat-cell *matCellDef="let record">{{ getEnteringWetBulb(record) | number: '1.0-1' }}</td>
  </ng-container>
  <ng-container matColumnDef="eft">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getTemperatureUnits()">EFT</th>
    <td mat-cell *matCellDef="let record">{{ getEnteringFluidTemperature(record) | number: '1.0-1' }}</td>
  </ng-container>
  <ng-container matColumnDef="totalCap">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getCapacityUnits()">Total Cap</th>
    <td mat-cell *matCellDef="let record">{{ getTotalCapacity(record) | number: '1.0-0' }}</td>
  </ng-container>
  <ng-container matColumnDef="sensibleCap">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getCapacityUnits()">Sensible Cap</th>
    <td mat-cell *matCellDef="let record">{{ getSensibleCapacity(record) | number: '1.0-0' }}</td>
  </ng-container>
  <ng-container matColumnDef="latentCap">
    <th mat-header-cell *matHeaderCellDef [matTooltip]="getCapacityUnits()">Latent Cap</th>
    <td mat-cell *matCellDef="let record">{{ getLatentCapacity(record) | number: '1.0-0' }}</td>
  </ng-container>
  <ng-container matColumnDef="active">
    <th class="centered-cell" mat-header-cell *matHeaderCellDef (click)="toggleActiveFlags()">Active</th>
    <td class="centered-cell" mat-cell *matCellDef="let record">
      <mat-checkbox class="cellCheckbox" [(ngModel)]="record.unitData.active"></mat-checkbox>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
  <tr [class.invalid]="isInvalidUnit(row)" [class.selected]="isSelected(row)" class="clickableRow" (click)="unitSelected(row)" mat-row *matRowDef="let row; columns: displayColumns;"></tr>
</table>
